var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "widM marTML" },
      [
        _vm.requiredConsents.length > 0
          ? [
              _vm._m(1),
              _vm._v(" "),
              _vm._l(_vm.attendingList, function(attendant, idx) {
                return _c(
                  "div",
                  {
                    key: "required" + idx,
                    staticClass: "pf23-itemAgree padBM",
                    class: { padTM: idx > 0 },
                    staticStyle: { "border-bottom": "1px solid #e3e3e3" }
                  },
                  [
                    _c("div", { staticClass: "floL fntP" }, [
                      _vm._v(
                        _vm._s(_vm.getAttendantName(attendant)) + " (필수)"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "floR" }, [
                      _c("div", { staticClass: "amway-theme txtR" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "action pf23-radioBtn radio-wrapper pf23-itemAgree-radio",
                            attrs: { id: "consent-require" }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "amw-radio-wrap radio-label focus"
                              },
                              [
                                _c("input", {
                                  staticClass: "amw-global-radio",
                                  attrs: {
                                    type: "radio",
                                    name: "required-consent" + idx,
                                    value: "Y",
                                    disabled: !_vm.infoAvailable
                                  },
                                  domProps: {
                                    checked: attendant.consents.required === "Y"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.selectConsentYn(
                                        attendant,
                                        "required",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "amw-radio-overlay"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "amw-label-radio-text" },
                                  [_vm._v("동의")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "amw-radio-wrap radio-label focus"
                              },
                              [
                                _c("input", {
                                  staticClass: "amw-global-radio",
                                  attrs: {
                                    type: "radio",
                                    name: "required-consent" + idx,
                                    value: "N",
                                    disabled: !_vm.infoAvailable
                                  },
                                  domProps: {
                                    checked: attendant.consents.required === "N"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.selectConsentYn(
                                        attendant,
                                        "required",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "amw-radio-overlay"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "amw-label-radio-text" },
                                  [_vm._v("동의 안함")]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "fntE padTS",
                  staticStyle: {
                    color: "#d91734",
                    "text-indent": "-0.6em",
                    "padding-left": "0.6em"
                  }
                },
                [
                  _vm._v(
                    "*각 동의 항목에는 참여하는 참가자들이 모두 읽고 동의 여부를 직접 선택 해주시기 바랍니다."
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.requiredConsents, function(consent, idx) {
                return _c(
                  "div",
                  {
                    key: consent.c_code,
                    class: { marTML: idx === 0 },
                    staticStyle: {
                      background: "#f3f3f3",
                      "border-top": "1px solid #e3e3e3"
                    }
                  },
                  [
                    _c("div", { staticClass: "widM" }, [
                      _c("div", { staticClass: "padTM padBM" }, [
                        _c("p", { staticClass: "fntP" }, [
                          _vm._v("[필수] " + _vm._s(consent.title))
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "txtR fntE padTS",
                            staticStyle: { color: "#00305e" }
                          },
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.openConsentPopup(consent)
                                  }
                                }
                              },
                              [_vm._v("자세히 보기 >")]
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              })
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.optionalConsents.length > 0
          ? [
              _c(
                "div",
                {
                  staticClass: "fntH6 fntL bold marTML marBM",
                  staticStyle: { color: "#2c2c2c" }
                },
                [_vm._v("선택항목 동의")]
              ),
              _vm._v(" "),
              _vm._l(_vm.attendingList, function(attendant, idx) {
                return _c(
                  "div",
                  {
                    key: "optional" + idx,
                    staticClass: "pf23-itemAgree padBM",
                    class: { padTM: idx > 0 },
                    staticStyle: { "border-bottom": "1px solid #e3e3e3" }
                  },
                  [
                    _c("div", { staticClass: "floL fntP" }, [
                      _vm._v(_vm._s(_vm.getAttendantName(attendant)))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "floR" }, [
                      _c("div", { staticClass: "amway-theme txtR" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "action pf23-radioBtn radio-wrapper pf23-itemAgree-radio"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "amw-radio-wrap radio-label focus",
                                attrs: { id: "consent-option" }
                              },
                              [
                                _c("input", {
                                  staticClass: "amw-global-radio",
                                  attrs: {
                                    type: "radio",
                                    name: "optional-consent" + idx,
                                    value: "Y",
                                    disabled: !_vm.infoAvailable
                                  },
                                  domProps: {
                                    checked: attendant.consents.optional === "Y"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.selectConsentYn(
                                        attendant,
                                        "optional",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "amw-radio-overlay"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "amw-label-radio-text" },
                                  [_vm._v("동의")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "amw-radio-wrap radio-label focus"
                              },
                              [
                                _c("input", {
                                  staticClass: "amw-global-radio",
                                  attrs: {
                                    type: "radio",
                                    name: "optional-consent" + idx,
                                    value: "N",
                                    disabled: !_vm.infoAvailable
                                  },
                                  domProps: {
                                    checked: attendant.consents.optional === "N"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.selectConsentYn(
                                        attendant,
                                        "optional",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "amw-radio-overlay"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "amw-label-radio-text" },
                                  [_vm._v("동의 안함")]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.optionalConsents, function(consent) {
                return _c(
                  "div",
                  {
                    key: consent.c_code,
                    staticClass: "marTML",
                    staticStyle: {
                      background: "#f3f3f3",
                      "border-top": "1px solid #e3e3e3",
                      "border-bottom": "1px solid #e3e3e3"
                    }
                  },
                  [
                    _c("div", { staticClass: "widM" }, [
                      _c("div", { staticClass: "padTM padBM" }, [
                        _c("p", { staticClass: "fntP" }, [
                          _vm._v("[선택] " + _vm._s(consent.title))
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "txtR fntE padTS",
                            staticStyle: { color: "#00305e" }
                          },
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.openConsentPopup(consent)
                                  }
                                }
                              },
                              [_vm._v("자세히 보기 >")]
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              })
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marTML pf23-subTit" }, [
      _c(
        "div",
        {
          staticClass: "widM fntH4 bold padTS padBS",
          staticStyle: { color: "#fff" }
        },
        [_vm._v("참가 약관 동의")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "fntH6 fntL bold marBSM",
        staticStyle: { color: "#2c2c2c" }
      },
      [_vm._v("필수항목 동의"), _c("span", { staticClass: "ico-must-astar" })]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f0dfcb2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f0dfcb2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/sydney/components/SurveyConsent.vue
// module id = null
// module chunks = 